export const SEARCH_RESULTS_LOADING = '@@reservble/search/SEARCH_RESULTS_LOADING';
export const SAVE_SEARCH_RESULTS = '@@reservble/search/SAVE_SEARCH_RESULTS';
